import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaCogs,
  FaPalette,
  FaBolt,
  FaGlobeAsia,
  FaShieldAlt,
  FaTrophy,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CustomEcommerceSolutionsInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Custom E-commerce Solutions in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Tailored for Your Success</Subheading>}
        heading={
          <Heading>
            Custom <span tw="text-primary-500">E-commerce Solutions</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver bespoke e-commerce solutions in **Bur
            Dubai**, designed to meet your unique business needs. From custom
            designs to advanced functionality, we create online stores that
            stand out and drive results.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce storefront on tablet
          "https://images.unsplash.com/photo-1546213290-e1b492ab3eee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile shopping app
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online store dashboard
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Custom Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Tailored E-commerce Solutions for Bur Dubai Businesses"
        description="We craft custom solutions to match your vision and goals."
        cards={[
          {
            icon: <FaCogs color="#ff5464" size={40} />,
            title: "Bespoke Functionality",
            description:
              "Custom features built to suit your business processes.",
          },
          {
            icon: <FaPalette color="#ff5464" size={40} />,
            title: "Unique Design",
            description: "Stand out with a one-of-a-kind store aesthetic.",
          },
          {
            icon: <FaBolt color="#ff5464" size={40} />,
            title: "High Performance",
            description: "Fast, responsive, and optimized for conversions.",
          },
          {
            icon: <FaGlobeAsia color="#ff5464" size={40} />,
            title: "Localized Expertise",
            description: "Designed for Bur Dubai’s diverse market and culture.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure & Scalable",
            description: "Robust platforms ready to grow with your business.",
          },
          {
            icon: <FaTrophy color="#ff5464" size={40} />,
            title: "Proven Success",
            description:
              "Trusted by Bur Dubai businesses for custom excellence.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Process for Custom E-commerce Solutions"
        description={
          <Description>
            We deliver tailored e-commerce platforms through a collaborative
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Deep dive into your business goals and
                requirements.
              </li>
              <li>
                Strategy: Plan a custom solution aligned with your vision.
              </li>
              <li>
                Design: Create unique, user-centric layouts and interfaces.
              </li>
              <li>Development: Build bespoke features and integrations.</li>
              <li>Testing: Ensure flawless performance across all devices.</li>
              <li>Support: Provide ongoing customization and maintenance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Web development process
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team planning e-commerce strategy
          "https://images.unsplash.com/photo-1472437774355-71ab6752b434?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai business district
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Discover Our Process"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Custom E-commerce Wins in Bur Dubai"
        description="Our tailored solutions have empowered local businesses."
        cards={[
          {
            icon: <FaCogs color="#ff5464" size={40} />,
            title: "Custom Workflow",
            description:
              "Built a unique inventory system, saving 20 hours weekly.",
          },
          {
            icon: <FaPalette color="#ff5464" size={40} />,
            title: "Brand Impact",
            description:
              "Increased customer engagement by 160% with custom design.",
          },
          {
            icon: <FaTrophy color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% of clients recommend our bespoke solutions.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={
          <Subheading>Ready for a Tailored E-commerce Store?</Subheading>
        }
        heading="Your Custom Solution Awaits in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset to create a custom e-commerce platform
            that reflects your brand and meets your unique needs in Bur Dubai.
            Let’s bring your vision to life!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online payment/e-commerce success
          "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline with Burj Khalifa
          "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Custom website design concept
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
